import { render, staticRenderFns } from "./ContentItemSetting.vue?vue&type=template&id=e92047ec"
import script from "./ContentItemSetting.vue?vue&type=script&lang=js"
export * from "./ContentItemSetting.vue?vue&type=script&lang=js"
import style0 from "./ContentItemSetting.vue?vue&type=style&index=0&id=e92047ec&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e92047ec')) {
      api.createRecord('e92047ec', component.options)
    } else {
      api.reload('e92047ec', component.options)
    }
    module.hot.accept("./ContentItemSetting.vue?vue&type=template&id=e92047ec", function () {
      api.rerender('e92047ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/ContentItemSetting.vue"
export default component.exports